// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WUOc","newExpiryDate":"styles_newExpiryDate__3Y8NF","footer":"styles_footer__2sE4B"};